import type React from "react";
import { useSelector } from "react-redux";

import ErrorComponent from "components/app/Error/ErrorComponent";
import { API_STATUS_CODES } from "legacy/constants/ApiConstants";
import { HOME_URL } from "legacy/constants/routes";
import ErrorPageHeader from "legacy/pages/common/ErrorPageHeader";
import { getIsSuperUser } from "legacy/selectors/usersSelectors";

export const SuperuserPageWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const isSuperUser = useSelector(getIsSuperUser);

  if (!isSuperUser) {
    return (
      <>
        <ErrorPageHeader />
        <ErrorComponent
          errorCode={API_STATUS_CODES.RESOURCE_FORBIDDEN}
          title={"You don’t have access"}
          errorMessage={`You need superuser permissions to use this feature.`}
          buttonText="Return home"
          buttonPath={HOME_URL}
        />
      </>
    );
  }

  return <>{children}</>;
};
